import { render, staticRenderFns } from "./Chem1LC_LabFundamentals_Q8.vue?vue&type=template&id=87ec86d0&"
import script from "./Chem1LC_LabFundamentals_Q8.vue?vue&type=script&lang=js&"
export * from "./Chem1LC_LabFundamentals_Q8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VRadio,VRadioGroup,VSimpleTable})
